// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1kgYt{display:-ms-flexbox;display:flex;padding:16px;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;height:85px;justify-content:center;width:128px}._1kgYt>svg{width:100%}@media (min-width:1024px){._1kgYt>svg{width:auto}}", ""]);
// Exports
exports.locals = {
	"MobileAppLoader": "_1kgYt"
};
module.exports = exports;
